import React from 'react';
import { AnimatedSection, ParallaxLayer } from './AnimatedSection';
import { BlurText, HeroBackground } from './Animations';
import { Link } from 'react-router-dom';
import { SplineBackground } from './SplineBackground';
import { ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  eyebrow?: string;
  headline: string;
  subhead: string;
  primaryCta?: {
    label: string;
    to: string;
  };
  secondaryCta?: {
    label: string;
    to: string;
  };
  graphic?: React.ReactNode;
  centered?: boolean;
}
export function HeroSection({
  eyebrow,
  headline,
  subhead,
  primaryCta,
  secondaryCta,
  graphic
}: HeroSectionProps) {
  return <section className="relative pt-[206px] pb-[214px] overflow-hidden" data-id="element-348">
      <div className="absolute inset-0 z-0" data-id="element-349">
        <SplineBackground data-id="element-350" />
      </div>

      <div className="section-container relative z-10 flex flex-col items-center text-center pointer-events-none" data-id="element-351">
        <div className="max-w-[768px] flex flex-col items-center gap-9" data-id="element-352">
          {eyebrow && <AnimatedSection data-id="element-353">
              <div className="inline-flex items-center px-3 py-1 border-l-2 border-picus-accent bg-picus-surface/50 backdrop-blur-sm" data-id="element-354">
                <span className="font-mono text-[12px] leading-[16px] font-semibold uppercase tracking-[2px] text-white" data-id="element-355">
                  {eyebrow}
                </span>
              </div>
            </AnimatedSection>}

          <div className="flex flex-col gap-3" data-id="element-356">
            <h1 className="text-white text-[48px] leading-[60px] tracking-[5.3px] uppercase font-sans font-light" data-id="element-357">
              <BlurText text={headline} data-id="element-358" />
            </h1>
          </div>

          <AnimatedSection delay={0.3} data-id="element-359">
            <p className="text-picus-muted text-[18px] leading-[24px] font-mono font-light max-w-[768px]" data-id="element-360">
              {subhead}
            </p>
          </AnimatedSection>

          {(primaryCta || secondaryCta) && <AnimatedSection delay={0.4} className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-4 pointer-events-auto" data-id="element-361">
              {primaryCta && <Link to={primaryCta.to} className="btn-primary" data-id="element-362">
                  {primaryCta.label}
                </Link>}
              {secondaryCta && <Link to={secondaryCta.to} className="btn-secondary" data-id="element-363">
                  {secondaryCta.label}
                </Link>}
            </AnimatedSection>}
        </div>

        {graphic && <ParallaxLayer speed={-0.1} data-id="element-364">
            <AnimatedSection delay={0.5} className="relative z-10 mt-24 w-full max-w-5xl mx-auto" data-id="element-365">
              {graphic}
            </AnimatedSection>
          </ParallaxLayer>}
      </div>
    </section>;
}